var map = {
	"./base.js": "VXDP",
	"./hth.js": "of+z",
	"./hthdk.js": "lpnF",
	"./hthno.js": "2cOg",
	"./hthse.js": "9xxg",
	"./keittiomaailma.js": "TZ0d",
	"./magnet.js": "Lpt4",
	"./magnettrade.js": "7Iui",
	"./marbodal.js": "omQm",
	"./novart.js": "982x",
	"./sigdal.js": "q/MD"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "v+ZX";